/* eslint no-undef: 0 */
/* eslint no-param-reassign: 0 */

// import constants from '../constants';
// import { eventsRetryOption } from './../constants/globalConstants';
// import RequestBuilder from './RequestBuilder';
// import RedAnalytics from './../utils/RedAnalytics';
import findIndex from 'lodash/findIndex';
import take from 'lodash/take';
// import store from './../reducers';

/**
 * @name : getUserIP Function
 * @description: To get the lat and log using the network IP
 */
export const getUserIP = () =>
  fetch('http://ip-api.com/json/').then((res) => res.json());

/**
 * @name : cookieStorageUtility Object
 * @description: To get,set and delete the items in cookies.
 */
export const cookieStorageUtility = {
  create: (name, value, hours) => {
    let expires = '';
    if (hours) {
      const date = new Date();
      const seconds = hours * 60 * 60 * 1000;
      date.setTime(date.getTime() + seconds);
      expires = `; expires=${date.toGMTString()}`;
    } else {expires = '';}
    if (value !== 'undefined' && typeof value !== 'undefined' && value !== null) {
      if (typeof value !== 'string') {
        document.cookie = `${name}=${encodeURIComponent(
          JSON.stringify(value)
        )}${expires};path=/`;
      } else {
        document.cookie = `${name}=${encodeURIComponent(
          value
        )}${expires};path=/`;
      }
    }
  },
  fetch: (name) => {
    const result = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    let outputToReturn = null;
    try {
      outputToReturn =
        result === null ? null : JSON.parse(decodeURIComponent(result[2]));
    } catch (error) {
      outputToReturn = decodeURIComponent(result[2]);
    }
    return outputToReturn;
  },
  delete: (name) => {
    cookieStorageUtility.create(name, '', -1);
  }
};

/**
 * @name : localStorageUtility Object
 * @description: To get,set and delete the items in localstorage.
 */
export const localStorageUtility = {
  create: (key, value) => {
    if (!window.localStorage) {
      cookieStorageUtility.create(key, value);
    } else if (value !== 'undefined' && typeof value !== 'undefined' && value !== null) {
      window.localStorage.setItem(key, JSON.stringify(value));
    }
  },
  fetch: (key) => {
    let result = null;
    if (!window.localStorage) {
      result = cookieStorageUtility.fetch(key);
    } else {
      const item = window.localStorage.getItem(key);
      try {
        result =
          item !== 'undefined' && typeof item !== 'undefined' && item !== null
            ? JSON.parse(item)
            : null;
      } catch (error) {
        result = item;
      }
    }
    return result;
  },
  delete: (key) => {
    if (!window.localStorage) {
      cookieStorageUtility.delete(key);
    } else {
      window.localStorage.removeItem(key);
    }
  }
};
/**
 * @description Deletes object from local storage with specified prefix
 */
export const deleteObjectWithPrefix = (objectName) => {
  if (objectName) {
    const list = []; // Array to hold the keys
    // Iterate over localStorage and insert the keys that meet the condition into arr
    for (let i = 0; i < localStorage.length; i += 1) {
      if (localStorage.key(i).indexOf(objectName) > -1) {
        list.push(localStorage.key(i));
      }
    }
    // Iterate over arr and remove the items by key
    for (let i = 0; i < list.length; i += 1) {
      localStorage.removeItem(list[i]);
    }
  }
};
/**
 * @name : sessionStorageUtility Object
 * @description: To get,set and delete the items in sessionStorage.
 */
export const sessionStorageUtility = {
  create: (key, value) => {
    if (!window.sessionStorage) {
      cookieStorageUtility.create(key, value);
    } else if (value !== 'undefined' && typeof value !== 'undefined' && value !== null) {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    }
  },
  fetch: (key) => {
    let result = null;
    if (!window.sessionStorage) {
      result = cookieStorageUtility.fetch(key);
    } else {
      const item = window.sessionStorage.getItem(key);
      try {
        result =
          item !== 'undefined' && typeof item !== 'undefined' && item !== null
            ? JSON.parse(item)
            : null;
      } catch (error) {
        result = item;
      }
    }
    return result;
  },
  delete: (key) => {
    if (!window.sessionStorage) {
      cookieStorageUtility.delete(key);
    } else {
      window.sessionStorage.removeItem(key);
    }
  }
};

/**
 * @name : getMobileOperatingSystem Function
 * @description: To get the device type.
 */
export const getMobileOperatingSystem = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'WINDOWS';
  }

  if (/android/i.test(userAgent)) {
    return 'android';
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios';
  }

  return 'unknown';
};
/**
 * @name : reTry Function
 * @description: To Retry any function with paramerter if not defined or loaded.
 */
// export const reTry = (callBackFunction, eventObj, options) => {
//   const eventOption = options;
//   if (eventOption.attemptToRetry > 0) {
//     setTimeout(() => {
//       eventOption.attemptToRetry -= 1;
//       if (eventsRetryOption.attemptToRetry !== -1) {
//         callBackFunction(eventObj);
//       }
//     }, eventOption.timeToRetry);
//   }
// };
export const initializeFirebase = () => {
  // Initialize Firebase
  if (firebase) {
    firebase.initializeApp(firebaseConfig);
    firebase.performance();
  }
  // firebase.analytics();
};
/**
 * @name : TriggerFirebase Function
 * @description: For Triggering the Google Analytics events
 */
/* export const TriggerFirebase = (eventObj) => {
  try {
    // ga('send', {
    //   hitType: 'event',
    //   eventCategory: eventObj.category,
    //   eventAction: eventObj.action,
    //   eventLabel: eventObj.label
    // });
    if (
      firebase &&
      firebase.apps &&
      firebase.apps.length === 0 &&
      firebaseConfig
    ) {
      initializeFirebase();
    }
    if (typeof (firebase) !== 'undefined') {
      firebase.analytics().logEvent(eventObj.eventLabel, eventObj.properties);
    }
  } catch (error) {
    reTry(TriggerFirebase, eventObj, eventsRetryOption.firebase);
  }
}; */
/**
 * @name : TriggerGa Function
 * @description: For Triggering the Google Analytics events
 */
/* export const TriggerGa = (eventObj) => {
  try {
    ga('send', {
      hitType: 'event',
      eventCategory: eventObj.category,
      eventAction: eventObj.action,
      eventLabel: eventObj.label,
    });
  } catch (error) {
    reTry(TriggerGa, eventObj, eventsRetryOption.ga);
  }
}; */
/* export const TriggerGaPageView = (eventObj) => {
  try {
    ga('send', {
      hitType: 'pageview',
      page: eventObj.properties.page,
    });
  } catch (error) {
    reTry(TriggerGa, eventObj, eventsRetryOption.ga);
  }
}; */
/**
 * @name : TriggerMixPanel Function
 * @description: For Triggering the mixpanel event;
 */
/* export const TriggerMixPanel = (eventObj) => {
  try {
    const tempProperties = eventObj.properties;
    const source = cookieStorageUtility.fetch('source');
    const tile = cookieStorageUtility.fetch('tile');
    const type = cookieStorageUtility.fetch('type');

    if (source) {
      tempProperties.source = source;
    }
    if (tile) {
      tempProperties.tile = tile;
    }
    if (type) {
      tempProperties.type = type;
    }
    if (typeof (mixpanel) !== 'undefined') {
      mixpanel.track(eventObj.eventLabel, tempProperties);
    }
    RedAnalytics.track(eventObj.eventLabel, tempProperties);
  } catch (error) {
    reTry(TriggerMixPanel, eventObj, eventsRetryOption.mixPixel);
  }
}; */
/**
 * @name : TriggerFbPixel Function
 * @description: For Triggering the FaceBook Pixel Events;
 */
/* export const TriggerFbPixel = (eventObj) => {
  try {
    fbq('track', eventObj.eventLabel, eventObj.properties);
  } catch (error) {
    reTry(TriggerFbPixel, eventObj, eventsRetryOption.fbPixel);
  }
}; */
/**
 * @name : TriggerBranch Function
 * @description: For Triggering the custom branch event;
 */
/* export const TriggerBranch = (eventObj) => {
  try {
    window.branch.logEvent(
      eventObj.name,
      {
        Name: eventObj.name,
        ...eventObj.properties,
      },
      (err) => {
        console.log(err);
      }
    );
  } catch (error) {
    reTry(TriggerBranch, eventObj, eventsRetryOption.branch);
  }
}; */
/**
 * @name : TriggerMoengage Function
 * @description: For Triggering the Moengage event;
 */
/* export const TriggerMoengage = (eventObj) => {
  try {
    window.Moengage.track_event(eventObj.name, {
      'Device Type': 'msite',
      ...eventObj.properties,
    });
  } catch (error) {
    reTry(TriggerMoengage, eventObj, eventsRetryOption.moengage);
  }
}; */
/**
 * @name : TriggerStandardBranch Function
 * @description: For Triggering the branch standard event;
 */
/* export const TriggerStandardBranch = (eventObj) => {
  try {
    window.branch.logEvent(
      eventObj.label,
      {
        ...eventObj.properties,
      },
      (err) => {
        console.log(err);
      }
    );
  } catch (error) {
    reTry(TriggerStandardBranch, eventObj, eventsRetryOption.branch);
  }
}; */
/**
 *  @name: isResidenceFlow Function
 *  @description : To make api call for loading scripts.
 */
export const isResidenceFlow = () => {
  const isResidence = sessionStorageUtility.fetch('isResidenceFlow');
  return isResidence && isResidence === true;
};

/**
 * @name : TriggerMoengage Function
 * @description: For Triggering the Moengage event;
 */
/* export const AddMoengageAttribute = (attr) => {
  try {
    attr.args = attr.args || [];
    window.Moengage[attr.functionName](...attr.args);
  } catch (error) {
    reTry(AddMoengageAttribute, attr, eventsRetryOption.moengage);
  }
}; */
/**
 * @name : GetUrlParams Function
 * @description: To Get the url params and create object
 */
export const GetUrlParams = () => {
  const vars = {};
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
    vars[key] = value;
  });
  return vars;
};

/**
 * @name : createUrlParams Function
 * @description: To create the url params
 * @param: params: this params object will be created as query params
 */
export const createParams = (params) => {
  if (!params) {
    return '';
  }
  const quesryString = Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join('&');
  return `${quesryString}`;
};

/**
 * @name : getFormattedDate Function
 * @description: To get the date formatted in dd-mm-yyyy format(you can get the future date also by passing the days count)
 */
export const formatDateToString = (dayCount, date) => {
  let d;
  if (date) {
    d = date;
  } else {
    d = new Date();
  }
  d.setDate(d.getDate() + dayCount);
  const dd = d.getDate() < 9 ? `0${d.getDate()}` : d.getDate();
  const mm = d.getMonth() + 1 < 10 ? `0${d.getMonth() + 1}` : d.getMonth() + 1;
  const yyyy = d.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
};
export const insertHTML = (() => {
  try {
    document.createRange().createContextualFragment('x');
    return (parent, data) => {
      parent.appendChild(document.createRange().createContextualFragment(data));
    };
  } catch (e) {
    return (parent, data) => {
      parent.insertAdjacentHTML('beforeend', data);
    };
  }
})();
/**
 * @name: addScript Function
 * @description: To Add the script files in head/body
 * @param {analyticsObject } : object which will have all the scripts to be added in html page.
 */
/* const addScript = (analyticsObject) => {
  const scriptPlace = {
    google_analytics: 'head',
    piwik: 'head',
    zoopim_chat: 'head',
    google_adword_js: 'head',
    general_js: 'head',
    gtm_js: 'body',
  };
  Object.keys(analyticsObject).forEach((key) => {
    const script = analyticsObject[key];
    if (script !== null) {
      const placetoAdd = scriptPlace[key];
      if (placetoAdd === 'head') {
        insertHTML(document.head, script);
      } else if (placetoAdd === 'body') {
        insertHTML(document.body, script);
      }
    }
  });
}; */
/**
 *  @name: removePrevBookingFlags Function
 *  @description : To remove club membership related flags associated with prev bookings.
 */
/* export const removePrevBookingFlags = () => {
  localStorageUtility.delete('isRCSelected');
  localStorageUtility.delete('rcPromoCode');
  localStorageUtility.delete('selectedRCPlanId');
  localStorageUtility.delete('addClubMembershipId');
  localStorageUtility.delete('redClubPurchase');
}; */

/**
 *  @name: loadScripts Function
 *  @description : To make api call for loading scripts.
 */
/* export const loadScripts = (params) => {
  RequestBuilder({
    url: `${constants.cdnPath}${
      constants.apiPath10
    }/load_analytics`,
    method: 'GET',
    params,
    excludeHeader: true,
  }).then((res) => addScript(res.analytics));
}; */

/**
 *  @name: getBasePath Function
 *  @description : To make api call for loading scripts.
 */
export const getBasePath = (path) => {
  let basePath = path;
  if (isResidenceFlow()) {
    basePath = `residence-${path}`;
  }
  return basePath;
};

/**
 * @function addPopularLocation
 * @description To manage popular location array in local storage
 * @param {Object} city object
 */
export const addPopularLocation = (cityObj) => {
  if (cityObj.popular_destination) {
    const popularLocations = localStorageUtility.fetch('popularLocations');
    if (popularLocations) {
      const index = findIndex(
        popularLocations,
        (o) => o.city[1] === cityObj.city[1]
      );
      if (index === -1) {
        // store only 5 locations in localstorage
        localStorageUtility.create(
          'popularLocations',
          take([cityObj].concat(popularLocations), 5)
        );
      } else {
        const temp = [...popularLocations];
        temp.splice(index, 1);
        // store only 5 locations in localstorage
        localStorageUtility.create(
          'popularLocations',
          take([cityObj].concat(temp), 5)
        );
      }
    } else {
      localStorageUtility.create('popularLocations', [cityObj]);
    }
  }
};

/**
 *  @name: isGojekFlow Function
 *  @description : To check source from cookies.
 */
export const isGojekFlow = () => {
  const source = cookieStorageUtility.fetch('source');
  return source ? source.toString().toUpperCase() === 'GOJEK' : false;
};

/**
 * @name : TriggerMixPanel Function
 * @description: For Triggering the mixpanel event;
 */
/* export const TriggerCleverTap = (eventObj) => {
  const state = store.getState();
  const isCorporateFlow = state.siteSettings.isCorporateSite;
  try {
    const tempProperties = eventObj.properties;
    const userInfo = localStorageUtility.fetch('userInfo');
    tempProperties.isCorporateFlow = false;
    if (isCorporateFlow) {
      tempProperties.isCorporateFlow = true;
    }
    tempProperties.Category = isResidenceFlow() ? 'KOOLKOST' : 'HOTELS';
    tempProperties['login status'] = false;
    tempProperties['Redclub Status'] = false;
    tempProperties.User_Type = 'New';
    if (!tempProperties.app_type) {
      tempProperties.App_Type = 'msite';
    }
    if (userInfo && userInfo.isLogin) {
      tempProperties['login status'] = userInfo.isLogin;
      tempProperties['Redclub Status'] = userInfo.club_member;
      if (userInfo.country_id !== null) {
        tempProperties.Nationality = userInfo.country_name;
      }
      tempProperties.User_Type =
        userInfo.my_bookings_count > 0 ? 'Repeat' : 'New';
      tempProperties.user_phone_number = userInfo.phone;
    } else {
      tempProperties['login status'] = false;
      tempProperties['Redclub Status'] = false;
      tempProperties.User_Type = 'New';
    }
    tempProperties.locale = `${window.globalLocale}-${
      window.globalCountryCode
    }`;
    if (typeof (clevertap) !== 'undefined') {
      clevertap.event.push(eventObj.eventLabel, tempProperties);
    }
  } catch (error) {
    reTry(TriggerCleverTap, eventObj, eventsRetryOption.clevertap);
  }
}; */
